/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSessionModel } from '../../models/patient-session-model';

export interface GetListPatientSessions$Params {
  patientID?: number;
}

export function GetListPatientSessions(http: HttpClient, rootUrl: string, params?: GetListPatientSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionModel>>> {
  const rb = new RequestBuilder(rootUrl, GetListPatientSessions.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientSessionModel>>;
    })
  );
}

GetListPatientSessions.PATH = '/api/Staff/GetListPatientSessions';
